// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1K6KX","info":"Note_info__2e_xv","note":"Note_note__HjQa2","actions":"Note_actions__3qfnZ"};